import React, { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets scroll position on client-side navigations.
 *
 * Marketing pages scroll the window; the signed-in app shell scrolls an inner
 * `[data-scroll-reset]` pane. Hash links still scroll to the matching element.
 */
export const ScrollToTop: React.FC = () => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.replace(/^#/, ''));
      const target = id ? document.getElementById(id) : null;
      if (target) {
        target.scrollIntoView();
        return;
      }
    }

    window.scrollTo(0, 0);
    document.querySelectorAll('[data-scroll-reset]').forEach((node) => {
      if (node instanceof HTMLElement) {
        node.scrollTop = 0;
        node.scrollLeft = 0;
      }
    });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
